<footer class="site-footer">
  <div class="site-footer-inner mx-auto max-w-7xl px-4 md:px-6">
    @let info = settingStore.companyInfo();

    <div class="site-footer-top">
      <div class="site-footer-brand">
        @if (info.logo) {
          <img [src]="info.logo" alt="Logo" class="site-footer-logo" />
        } @else {
          <img [src]="defaultLogoUrl" alt="Logo" class="site-footer-logo site-footer-default-logo" />
        }
        @if (info.name) {
          <strong>{{ info.name }}</strong>
        }
      </div>
    </div>

    <nav class="site-footer-terms" [attr.aria-label]="'LAYOUT.FOOTER.TERMS_ARIA_LABEL' | translate">
      @if (screenSizeStore.isMobileSize()) {
        <a [routerLink]="['/terms', 'service']">{{ 'TERMS.TYPE.SERVICE' | translate }}</a>
        <a [routerLink]="['/terms', 'privacy']">{{ 'TERMS.TYPE.PRIVACY' | translate }}</a>
        <a [routerLink]="['/terms', 'marketing']">{{ 'TERMS.TYPE.MARKETING' | translate }}</a>
      } @else {
        <a href="/terms/service?view=window" target="_blank" rel="noopener noreferrer">{{ 'TERMS.TYPE.SERVICE' | translate }}</a>
        <a href="/terms/privacy?view=window" target="_blank" rel="noopener noreferrer">{{ 'TERMS.TYPE.PRIVACY' | translate }}</a>
        <a href="/terms/marketing?view=window" target="_blank" rel="noopener noreferrer">{{ 'TERMS.TYPE.MARKETING' | translate }}</a>
      }
    </nav>

    <dl class="site-footer-info">
      @if (info.ceo) {
        <div>
          <dt>{{ 'LAYOUT.FOOTER.CEO' | translate }}</dt>
          <dd>{{ info.ceo }}</dd>
        </div>
      }
      @if (info.registrationNumber) {
        <div>
          <dt>{{ 'LAYOUT.FOOTER.REG_NUMBER' | translate }}</dt>
          <dd>{{ info.registrationNumber }}</dd>
        </div>
      }
      @if (info.fullAddress) {
        <div class="site-footer-info-wide">
          <dt>{{ 'LAYOUT.FOOTER.ADDRESS' | translate }}</dt>
          <dd>{{ info.fullAddress }}</dd>
        </div>
      }
      @if (info.tel) {
        <div>
          <dt>{{ 'LAYOUT.FOOTER.TEL' | translate }}</dt>
          <dd>{{ info.tel }}</dd>
        </div>
      }
      @if (info.email) {
        <div>
          <dt>{{ 'LAYOUT.FOOTER.EMAIL' | translate }}</dt>
          <dd>{{ info.email }}</dd>
        </div>
      }
    </dl>

    <div class="site-footer-copyright">
      @if (info.copyright) {
        <p>{{ info.copyright }}</p>
      } @else {
        <p>
          (c) {{ currentYear }} {{ info.name || ('LAYOUT.FOOTER.COMPANY_NAME' | translate) }}.
          {{ 'LAYOUT.FOOTER.ALL_RIGHTS_RESERVED' | translate }}
        </p>
      }
    </div>
  </div>
</footer>
